import { takeEvery, all, call, put } from 'redux-saga/effects';

import * as types from './usersActionTypes';
import * as actions from './usersActions';
import * as endpoints from '../../services/endpoints';
import { handleSagaError } from '../../helpers/SagaErrorHandler';
import * as alert from '../alert/alertActions';
import { translations } from '../../translations';

const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'tr';
};

const t = (key) => {
  const language = getCurrentLanguage();
  return translations[language]?.[key] || translations['tr'][key] || key;
};

console.log('Saga - Imported action types:', types);
console.log('Saga - CHANGE_USER_PASSWORD_REQUEST:', types.CHANGE_USER_PASSWORD_REQUEST);

function* getUserSaga(action) {
  try {
    console.log('getUserSaga action:', action);
    
    const userData = JSON.parse(localStorage.getItem('user'));
    const sessionUserId = localStorage.getItem('sessionUserId');
    
    const userId = sessionUserId || userData?.sessionUserId || userData?.user?.sessionUserId;
    
    const payload = {
      SessionUserId: String(userId),
      UserId: userId
    };

    console.log('API payload:', payload);
    console.log('User data from localStorage:', userData);
    console.log('SessionUserId from localStorage:', sessionUserId);
    console.log('Final userId:', userId);
    
    if (!userId || userId === 'undefined') {
      console.error('SessionUserId not found in localStorage');
      
      yield put(
        alert.setAlertAction({
          title: t('sessionTimeoutTitle'),
          text: t('userSessionNotFound'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.getUserErrorAction({
        message: t('userSessionNotFound')
      }));
      return;
    }
    
    const { data } = yield call(endpoints.getUsers, payload);
    console.log('API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.error('API Business Logic Error:');
      console.error('Error Code:', data.Result.ErrorCode);
      console.error('Error Description:', data.Result.ErrorDescription);
      
      yield put(
        alert.setAlertAction({
          title: t('apiError'),
          text: data.Result.ErrorDescription || t('dataLoadError'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.getUserErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    yield put(actions.getUserDataAction(data));
  } catch (e) {
    console.error('getUserSaga error:', e);
    yield call(handleSagaError, e, action, actions.getUserErrorAction);
  }
}

function* createUserSaga(action) {
  try {
    console.log('createUserSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create user API payload:', payload);
    
    const { data } = yield call(endpoints.createUser, payload);
    console.log('Create user API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.log('API returned error:', data.Result);
      
      yield put(
        alert.setAlertAction({
          title: t('apiError'),
          text: data.Result.ErrorDescription || t('saveError'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.createUserErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    yield put(actions.createUserDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      console.log("User created successfully");
      
      yield put(
        alert.setAlertAction({
          title: t('itemCreated'),
          text: t('userCreated'),
          variant: 'success',
        }),
      );
      
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/users');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createUserSaga error:', e);
    yield call(handleSagaError, e, action, actions.createUserErrorAction);
  }
}

function* updateUserSaga(action) {
  try {
    console.log('updateUserSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update user API payload:', payload);
    
    const { data } = yield call(endpoints.updateUser, payload);
    console.log('Update user API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.log('API returned error:', data.Result);
      
      yield put(
        alert.setAlertAction({
          title: t('apiError'),
          text: data.Result.ErrorDescription || t('updateError'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.updateUserErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    yield put(actions.updateUserDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(
        alert.setAlertAction({
          title: t('itemUpdated'),
          text: t('userUpdated'),
          variant: 'success',
        }),
      );
      
      yield put(actions.getUserRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/users');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateUserSaga error:', e);
    yield call(handleSagaError, e, action, actions.updateUserErrorAction);
  }
}

function* deleteUserSaga(action) {
  try {
    console.log('deleteUserSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete user API payload:', payload);
    
    const { data } = yield call(endpoints.deleteUser, payload);
    console.log('Delete user API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.log('API returned error:', data.Result);
      
      yield put(
        alert.setAlertAction({
          title: t('apiError'),
          text: data.Result.ErrorDescription || t('deleteError'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.deleteUserErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    yield put(actions.deleteUserDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(
        alert.setAlertAction({
          title: t('itemDeleted'),
          text: t('userDeleted'),
          variant: 'success',
        }),
      );
      
      yield put(actions.getUserRequestAction());
    }
    
  } catch (e) {
    console.error('deleteUserSaga error:', e);
    yield call(handleSagaError, e, action, actions.deleteUserErrorAction);
  }
}

function* resetUserPasswordSaga(action) {
  try {
    console.log('resetUserPasswordSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Reset password API payload:', payload);
    
    const { data } = yield call(endpoints.resetUserPassword, payload);
    console.log('Reset password API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.log('API returned error:', data.Result);
      
      yield put(
        alert.setAlertAction({
          title: t('passwordResetError'),
          text: data.Result.ErrorDescription || t('passwordResetErrorMessage'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.resetUserPasswordErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    yield put(actions.resetUserPasswordDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(
        alert.setAlertAction({
          title: t('passwordResetSuccess'),
          text: t('passwordResetSuccessMessage'),
          variant: 'success',
        }),
      );
    }
    
  } catch (e) {
    console.error('resetUserPasswordSaga error:', e);
    yield call(handleSagaError, e, action, actions.resetUserPasswordErrorAction);
  }
}

function* changeUserPasswordSaga(action) {
  console.log('changeUserPasswordSaga TRIGGERED!', action);
  
  try {
    console.log('changeUserPasswordSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Change password API payload:', payload);
    
    const { data } = yield call(endpoints.changeUserPassword, payload);
    console.log('Change password API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.log('API returned error:', data.Result);
      
      yield put(
        alert.setAlertAction({
          title: t('passwordChangeError'),
          text: data.Result.ErrorDescription || t('passwordChangeError'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.changeUserPasswordErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    yield put(actions.changeUserPasswordDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(
        alert.setAlertAction({
          title: t('passwordChangedSuccessfully'),
          text: t('passwordChangedSuccessfully'),
          variant: 'success',
        }),
      );
      
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }

  } catch (e) {
    console.error('changeUserPasswordSaga error:', e);
    yield call(handleSagaError, e, action, actions.changeUserPasswordErrorAction);
  }
}

function* getUserDetailsSaga(action) {
  try {
    console.log('getUserDetailsSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Get user details API payload:', payload);
    
    const { data } = yield call(endpoints.getUserDetails, payload);
    console.log('Get user details API response:', data);
    
    if (data.Result && data.Result.ErrorCode !== 0) {
      console.log('API returned error:', data.Result);
      
      yield put(
        alert.setAlertAction({
          title: t('apiError'),
          text: data.Result.ErrorDescription || t('dataLoadError'),
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      yield put(actions.getUserDetailsErrorAction({
        response: {
          data: data
        }
      }));
      return;
    }
    
    // API'den dönen veriyi direkt reducer'a gönder
    console.log('Sending to reducer - getUserDetailsDataAction:', data);
    yield put(actions.getUserDetailsDataAction(data));
    
  } catch (e) {
    console.error('getUserDetailsSaga error:', e);
    yield call(handleSagaError, e, action, actions.getUserDetailsErrorAction);
  }
}

// Watcher Sagas
function* watchGetUser() {
  yield takeEvery(types.GET_USER_REQUEST, getUserSaga);
}

function* watchCreateUser() {
  yield takeEvery(types.CREATE_USER_REQUEST, createUserSaga);
}

function* watchUpdateUser() {
  yield takeEvery(types.UPDATE_USER_REQUEST, updateUserSaga);
}

function* watchDeleteUser() {
  yield takeEvery(types.DELETE_USER_REQUEST, deleteUserSaga);
}

function* watchResetPassword() {
  yield takeEvery(types.RESET_USER_PASSWORD_REQUEST, resetUserPasswordSaga);
}

function* watchChangePassword() {
  yield takeEvery(types.CHANGE_USER_PASSWORD_REQUEST, changeUserPasswordSaga);
}

function* watchGetUserDetails() {
  yield takeEvery(types.GET_USER_DETAILS_REQUEST, getUserDetailsSaga);
}

export function* usersSaga() {
  yield all([
    watchGetUser(),
    watchCreateUser(),
    watchUpdateUser(),
    watchDeleteUser(),
    watchResetPassword(),
    watchChangePassword(),
    watchGetUserDetails(),
  ]);
}